// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f8f0a087","744":"792be50b","801":"7d562bc2"}[chunkId] + ".chunk.js";
};